import { fbt } from 'fbtee'

export function FilterTipBody() {
  return (
    <span className="flex flex-col gap-0.5">
      <span>{fbt('Just your picks', 'First line of the festival-mode coachmark on the schedule filter chip')}</span>
      <span className="text-muted-foreground">
        {fbt(
          'Tap to highlight the sets you’ve hearted',
          'Second line of the festival-mode coachmark on the schedule filter chip: tapping it highlights the sets the user hearted or marked going',
        )}
      </span>
    </span>
  )
}
